import { render, staticRenderFns } from "./SimpleCarousel.vue?vue&type=template&id=200dcd2d&scoped=true&"
import script from "./SimpleCarousel.vue?vue&type=script&lang=js&"
export * from "./SimpleCarousel.vue?vue&type=script&lang=js&"
import style0 from "./SimpleCarousel.vue?vue&type=style&index=0&id=200dcd2d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "200dcd2d",
  null
  
)

export default component.exports